import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {  SnackService, SnackServiceMsgComponent,
  SnackServiceSpinnerComponent,
  SnackServicePermissionMessageComponent } from './snack.service';
import { VendorModule } from '../core/vendor.module';
import { NavigationService } from './navigation.service';
import { UpdateEventService } from './update-event.service';
import { MediaService } from './media.service';
import { ScrollComunicationService } from './scroll-comunication.service';
import { ScrollDirective } from './scroll.directive';
import { EmailPatternValidator } from './email-pattern.validator';
import { TextTrimWhiteSpaceValidator } from './text-trim-white-space.validator';
import { DNIValidator } from './dni.validator';
import { NestableFormDirective } from './nesteable-form.directive';
import { FormValidatorService } from './form-validator.service';
import { PasswordStrengthValidator } from './password-strength.validator';
import { NumberPositiveIntegerValidator } from './number-positive-integer.validator';
import { DateValidator } from './date.validator';
import { DateDDMMYYStringValidator } from './date-ddmmyy.validator';

import { StrengthPasswordService } from './strength-password.service';
import { ExistsRoleNameValidator } from './exists-role-name.validator';
import { ExistsUserNameValidator } from './exists-user-name.validator';
import { MenorEdadValidator } from './menor-edad.validator';
import { DateNoBeforeNowValidator } from './date-no-before-now.validator';
import { ConfigNumberPatternValidator } from './config-number-pattern.validator';

import {CsvmapperService} from './csvmapperService';

const imports = [
  CommonModule,
  VendorModule,
];

const declarations = [
  SnackServiceMsgComponent,
  SnackServiceSpinnerComponent,
  SnackServicePermissionMessageComponent,
  ScrollDirective,
  EmailPatternValidator,
  TextTrimWhiteSpaceValidator,
  NestableFormDirective,
  DNIValidator,
  PasswordStrengthValidator,
  NumberPositiveIntegerValidator,
  DateValidator,
  DateDDMMYYStringValidator,
  ExistsRoleNameValidator,
  ExistsUserNameValidator,
  MenorEdadValidator,
  DateNoBeforeNowValidator,
  ConfigNumberPatternValidator,

];

@NgModule({
  imports, declarations,
  providers: [
    FormValidatorService,
    SnackService,
    NavigationService,
    UpdateEventService,
    MediaService,
    ScrollComunicationService,
    StrengthPasswordService,
    CsvmapperService,
  ],
  exports: [
    ...imports,
    ...declarations,
  ],
  entryComponents: [
    SnackServiceMsgComponent,
  ],
})
export class SharedServicesModule { }



// WEBPACK FOOTER //
// ./src/app/shared-services/shared-services.module.ts